import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signicatDocCapture: {
    redirectUrl: "",
  },
  success: false,
  errorMessage: ''
};

const signicatSlice = createSlice({
  name: "signicat",
  initialState,
  reducers: {
    setSignicatDocCapture(state, action) {
      state.signicatDocCapture = action.payload;
    },
    setSignicatError(state, action) {
      state.success = false;
      state.errorMessage = action.payload?.error;
    },
  },
});

export const signicatActions = signicatSlice.actions;
export default signicatSlice;
